import styled from 'styled-components';

export const Container = styled.svg`
  fill: #fff;
  width: 1.6rem;
  height: 1.6rem;
`;
